/** يطابق صيغة topics في تطبيق Flutter */

export const SUPER_ADMIN_TOPIC = 'superadmin'

export function sanitizeFcmTopicPart(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
}

export function officeTopic(cityEn) {
  const part = sanitizeFcmTopicPart(cityEn)
  return part ? `office${part}` : ''
}

export function cityAdminTopic(cityEn) {
  const part = sanitizeFcmTopicPart(cityEn)
  return part ? `cityadmin${part}` : ''
}

export function entityTopic(entityId) {
  const part = sanitizeFcmTopicPart(entityId)
  return part ? `entity${part}` : ''
}
